import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=b7989d1a&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7989d1a')) {
      api.createRecord('b7989d1a', component.options)
    } else {
      api.reload('b7989d1a', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=b7989d1a&", function () {
      api.rerender('b7989d1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y5dtU1ZP57HR/JS/pricehelp.vue"
export default component.exports